import { LoginInfo } from "@/store";

const PRINT_STORAGE_KEY = "admin-print-login-infos";
const PRINT_STORAGE_TTL_MS = 10 * 60 * 1000;

type PrintStoragePayload = {
  expiresAt: number;
  loginInfos: LoginInfo[];
};

export function savePrintLoginInfos(
  targetWindow: Window,
  loginInfos: LoginInfo[]
): void {
  const payload: PrintStoragePayload = {
    expiresAt: Date.now() + PRINT_STORAGE_TTL_MS,
    loginInfos
  };

  targetWindow.sessionStorage.setItem(
    PRINT_STORAGE_KEY,
    JSON.stringify(payload)
  );
}

export function consumePrintLoginInfos(): LoginInfo[] | null {
  const storedValue = window.sessionStorage.getItem(PRINT_STORAGE_KEY);

  if (!storedValue) {
    return null;
  }

  window.sessionStorage.removeItem(PRINT_STORAGE_KEY);

  try {
    const payload = JSON.parse(storedValue) as PrintStoragePayload;
    if (!Array.isArray(payload.loginInfos) || payload.expiresAt < Date.now()) {
      return null;
    }

    return payload.loginInfos;
  } catch {
    return null;
  }
}
